import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { Nature, INatures } from '../models/nature.model';
import { environment } from '../../../environments/environment';
import { InlineResponse } from '../models/inline-response.model';

const options = {
  headers: new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class NatureClientService {
  private apiURL = environment.apiURL;

  constructor(private http: HttpClient) {}

  public getNatureData(): Observable<INatures> {
    return this.http.get<INatures>(this.apiURL + '/services/nature');
  }

  public saveNatureData(codeHecate: number, designation: string): Observable<InlineResponse> {
    let params = new HttpParams()
      .set('codeHecate', codeHecate.toString())
      .set('designation', designation)
      .set('oper', 'add')
      .set('id', (Math.floor(Math.random() * (999999999 - 1111111 + 1)) + 1111111).toString());

    return this.http.post<InlineResponse>(this.apiURL + '/services/nature', params, options);
  }

  public editNatureData(nature: Nature): Observable<InlineResponse> {
    let params = new HttpParams().set('codeHecate', nature.codeHecate).set('designation', nature.designation).set('oper', 'edit').set('id', nature.id);

    return this.http.post<InlineResponse>(this.apiURL + '/services/nature', params, options);
  }
}
